import { Component, Input, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-menu-component',
  templateUrl: './menu-component.component.html',
  styleUrls: ['./menu-component.component.scss']
})
export class MenuComponentComponent implements OnInit {

  @Input() content: any;
  @Input() urlComponent: any;
  public currentCategory = '';

  constructor(public router: Router) { }

  ngOnInit(): void {
    this.router.events.subscribe((event: Event) => {
       if (event instanceof NavigationEnd) { 
          this.currentCategory = event.url.split('#')[1];
       }
    });
  }
}
